// Quick Buy Immediate Feedback Handler
// Provides instant visual feedback for mobile Safari and other browsers

class QuickBuyFeedback {
  constructor() {
    this.init();
  }

  init() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    // Use capturing phase to run before ProductForm disables buttons
    document.addEventListener('submit', this.handleFormSubmit.bind(this), true);
    
    // Clean up loading states when cart operation completes
    document.addEventListener('variant:add', this.handleVariantAdd.bind(this));
    document.addEventListener('cart:error', this.handleCartError.bind(this));
  }

  handleFormSubmit(event) {
    // Only handle quick buy forms
    if (!event.target.classList.contains('quick-buy-form')) {
      return;
    }

    const form = event.target;
    const button = form.querySelector('button[type="submit"]');
    
    if (!button || button.disabled) {
      return;
    }

    // Show immediate loading feedback
    this.showLoadingState(button);

    // Optimistically close modal after short delay for better UX
    // setTimeout(() => {
    //   this.closeQuickBuyModal();
    // }, 100);
  }

  showLoadingState(button) {
    const sizeText = button.querySelector('.size-text');
    const loadingSpinner = button.querySelector('.loading-spinner');
    
    if (sizeText && loadingSpinner) {
      // Fade out size text and show spinner
      sizeText.classList.add('opacity-0');
      loadingSpinner.classList.remove('hidden');
      
      // Prevent additional clicks
      button.classList.add('pointer-events-none');
      
      // Add subtle visual feedback
      button.style.transform = 'scale(0.95)';
      setTimeout(() => {
        button.style.transform = '';
      }, 150);
    }
  }

  hideLoadingState(button) {
    const sizeText = button.querySelector('.size-text');
    const loadingSpinner = button.querySelector('.loading-spinner');
    
    if (sizeText && loadingSpinner) {
      sizeText.classList.remove('opacity-0');
      loadingSpinner.classList.add('hidden');
      button.classList.remove('pointer-events-none');
    }
  }

  hideAllLoadingStates() {
    const buttons = document.querySelectorAll('.quick-buy-size-btn');
    buttons.forEach(button => this.hideLoadingState(button));
  }

  closeQuickBuyModal() {
    // Try different modal selectors that might be open
    const modalSelectors = [
      'quick-buy-modal[open]',
      'x-modal[open]',
      '[data-modal-id][open]',
      '.modal[open]'
    ];

    for (const selector of modalSelectors) {
      const modal = document.querySelector(selector);
      if (modal && typeof modal.hide === 'function') {
        modal.hide();
        break;
      }
    }
  }

  handleVariantAdd(event) {
    // Clean up all loading states when item is successfully added
    this.hideAllLoadingStates();
  }

  handleCartError(event) {
    // Clean up loading states on error
    this.hideAllLoadingStates();
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new QuickBuyFeedback();
  });
} else {
  new QuickBuyFeedback();
}
